 /**  
 *   THIS CLASS CHECK FROM STORE PRODUCT 
 *   ID AND CHECK FORM BACKEND IF THIS PRODUCT ID HAS ANY VALUES
 *   DOCUMENTS TO DOWNLOAD THEN ACTIVATE O DEACTIVATE CHECKBOX 
 */
import Axios from "axios";
import is_localhost from "./class_is_localhost";
export default class new_product_link_search {
  show_new_on_product ( store ) {
  //  let that = store;
    let th = this;
    let params = new URLSearchParams();
    let ur = new is_localhost();
    let url = ur.return_url_website();
    params.append('action', 'show_new_on_product');
    params.append('ID', store.product_store.CODICE_UNIVOCO);
    params.append('LANG', store.product.language);
    Axios.post(
      url+"wp-admin/admin-ajax.php",
      params
    )
      .then(function (response) {
  //console.log(response);
  try {
    // RIMUOVI SE ESISTE NEW
    console.info('RESPONSE',response);
    console.info('new_product_link');

    // esiste elemento new ? 
    // let new_el_exist = false;
    let new_el = document.querySelector(".new_element_vedi_nel_museo");
    if (new_el !== null) {
      // new_el_exist = true;
      // se esiste rimuovilo 
      new_el.remove();
    }
    // seleziona l'elemento occhio centrato


    try {
  
      if (response.data.codicelink2D != false){
        console.info('esiste codice link 2d');
        th.if_exist_remove('.new_element_conf_ambiente');
        th.insert_configuratore_ambiente(response.data.codicelink2D);
      }else{
        console.info('non esiste codice link 2d');
        th.if_exist_remove('.new_element_conf_ambiente');
        //new_element_conf_ambiente new_element_conf_prodotto
      }
      if (response.data.codicelink3D != false){
        th.if_exist_remove('.new_element_conf_prodotto');
        th.insert_configuratore_prodotto(response.data.codicelink3D);
        console.info('esiste codice link 3d');
      }else{
        console.info('non esiste codice link 3d');
        th.if_exist_remove('.new_element_conf_prodotto');
      }
      if (response.data.codicelink != false){
        th.if_exist_remove('.new_element_vedi_nel_museo');
        th.insert_new_museo(response.data.codicelink);
        console.info('esiste codice link museo');
      }else{
        console.info('non esiste codice link museo');
        th.if_exist_remove('.new_element_vedi_nel_museo');
      }

    } catch (error) {
      console.log(error);
    }


} catch (error) {
    console.log(error);

}
      })
      .catch(function (error) {
        console.log(error);
      });
}




  if_exist_remove(classname){
    let new_el = document.querySelector(classname);
    if (new_el !== null) {
      // new_el_exist = true;
      // se esiste rimuovilo 
      new_el.remove();
    }
  }


  insert_new_museo(index){
    let oc = document.querySelector(".occhio-centrato");
    // seleziona il padre
    let t = oc.closest('div[class="elementor-image"]');
    let  tttt = '<div id="" class="occhio-centrato new_element_vedi_nel_museo 2" style="right:8% !important;     bottom: 0% !important;"> <a href="https://vistosi.it/vistosivirtualmuseum/index.htm?media-index='+index+'">  <input type="image" style="padding:0px"; src="https://vistosi.it/risorse/newlink.svg" /> <h6 style="color:#686868; font-weight: 600; font-size:12px; max-width:100px; text-align: center">Vedi nel padiglione novità </h6> </a> </div> ';    // aggiungi elemento
    // aggiungi alla fine di tutto l'html;
    t.insertAdjacentHTML('afterend', tttt);
 
  }

  insert_configuratore_prodotto(link){
    let oc = document.querySelector(".occhio-centrato");
    // seleziona il padre
    let t = oc.closest('div[class="elementor-image"]');
    let  tttt = '<div id="" class="occhio-centrato new_element_conf_prodotto 2" style="right:8% !important;  bottom:22% !important;"> <a href="'+link+'">  <input type="image" style="padding:0px"; src="https://vistosi.it/risorse/confprodotto.svg" /> <h6 style="color:#686868; font-weight: 600; font-size:12px; max-width:100px; text-align: center"> Configuratore prodotto </h6> </a> </div> ';    // aggiungi elemento
    // aggiungi alla fine di tutto l'html;
    t.insertAdjacentHTML('afterend', tttt);
 
  }
  insert_configuratore_ambiente(link){
    let oc = document.querySelector(".occhio-centrato");
    // seleziona il padre
    let t = oc.closest('div[class="elementor-image"]');
    let  tttt = '<div id="" class="occhio-centrato new_element_conf_ambiente  2" style="right:8% !important; bottom:12% !important;"> <a href="'+link+'">  <input type="image" style="padding:0px"; src="https://vistosi.it/risorse/confambiente.svg" /> <h6 style="color:#686868; font-weight: 600; font-size:12px; max-width:100px; text-align: center"> Configuratore ambiente </h6> </a> </div> ';    // aggiungi elemento
    // aggiungi alla fine di tutto l'html;
    t.insertAdjacentHTML('afterend', tttt);
 
  }
      
}
